import { useState, useCallback } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowLeft, ArrowRight } from "lucide-react";

const TESTIMONIALS = [
  {
    quote:
      "We have known Jimmie for almost 12 years now. He is so professional, friendly, and trustworthy. He has done emergency calls for us and goes beyond to make sure that the fish are properly taken care of. We are extremely happy with Jimmy and recommend him to everyone!",
    name: "Jeannie Clout",
  },
  {
    quote:
      "Jimmie Hernandez with Seatech Aquariums is simply the best. In our rookie years of starting up reef and saltwater aquariums, we struggled with livestock and water quality. After contacting SeaTech Aquariums online, Jimmie impressed us with the initial consultation and provided the expertise that any level (novice to expert) aquarium owner is looking for. Seatech now handles our aquarium maintenance and over the last 5 years, we have not lost 1 fish – which is absolutely amazing compared to our personal experiences of going back and forth to the fish store for new livestock on a very frequent basis. For our professional aquarium maintenance services from SeaTech, Jimmie always communicates arrival times and uses what we consider a white-glove service – always with the utmost professional and attention to detail. Jimmie brings RODI water, all food supplies, nutrients and even hardware for the aquarium as needed. Once you contact Seatech Aquariums, you will immediately know you made the right decision and you can finally enjoy your aquarium investment and hobby for years to come.",
    name: "James and Denise Titus",
  },
  {
    quote:
      "I have had the extreme pleasure of working with Jimmie and Seatech for about six years – during that time I have come to value them more than I can say. They never make me feel that my questions are \u201Ctoo simple\u201D and Jimmie always has or quickly finds the answers for me. He has patience beyond that of a normal person and is straightforward with his answers. I believe in him and trust him implicitly. His knowledge base is very extensive and he always is looking to improve – not only his service but also in his dealings with the clients. I would wholeheartedly recommend this company and especially Jimmie and have done so on frequent occasions. They are a PLEASURE to do business with and I look forward to a future with their company.",
    name: "Cristy Klonowski",
  },
  {
    quote:
      "I have a 125 gallon Salt Water Aquarium that I have had for over 10 years. Finding someone to help me maintain my tank has been a constant overwhelming problem. Two of my grown children also had 125 gallon tanks but finally gave up. After many dollars and years of struggling, I happened upon Jimmie Hernandez at an aquarium shop. He said he would take a look at my tank and assured me he could make my tank beautiful, healthy and a joy to have in my home. He did just what he said he would do! He is prompt when he comes to service it, he is knowledgeable, his fees are reasonable, and most of all, he is available to help me if I need him. Often when I see a fish I like, all I have to do is text him, and he will advise me if that particular fish would be a good fit with my tank. When I do add a new fish he always calls to check on how my new fish is doing. He has been a godsend to me and I am very lucky to have him helping me. I would recommend him to anyone who has a tank or thinking of setting one up. He has a wonderful reputation in the community and I so appreciate his diligent, dedicated service.",
    name: "Margaret S",
  },
];

export const Testimonials = () => {
  const [index, setIndex] = useState(0);
  const [dir, setDir] = useState(1);

  const go = useCallback((d) => {
    setDir(d);
    setIndex((i) => (i + d + TESTIMONIALS.length) % TESTIMONIALS.length);
  }, []);

  const t = TESTIMONIALS[index];

  return (
    <section id="testimonials" data-testid="testimonials-section" className="relative py-10 lg:py-14">
      <div className="w-full max-w-[1860px] mx-auto px-5 lg:px-14">
        <div className="relative rounded-[2rem] bg-[#5a3fe0] px-14 lg:px-28 py-16 lg:py-24 overflow-hidden">
          <button
            data-testid="testimonial-prev"
            onClick={() => go(-1)}
            aria-label="Previous testimonial"
            className="absolute left-4 lg:left-8 top-1/2 -translate-y-1/2 text-white/70 hover:text-white transition-colors"
          >
            <ArrowLeft size={34} strokeWidth={1.4} />
          </button>
          <button
            data-testid="testimonial-next"
            onClick={() => go(1)}
            aria-label="Next testimonial"
            className="absolute right-4 lg:right-8 top-1/2 -translate-y-1/2 text-white/70 hover:text-white transition-colors"
          >
            <ArrowRight size={34} strokeWidth={1.4} />
          </button>

          <div className="text-center">
            <p className="font-body font-light text-sm lg:text-base text-white/85 mb-5">Client Testimonials</p>
            <h2 className="font-title text-5xl lg:text-7xl text-white">Client Stories</h2>
            <div className="mt-6 mb-2 text-white text-lg tracking-[0.3em]">★★★★★</div>

            <div className="min-h-[240px] flex flex-col items-center justify-center">
              <AnimatePresence mode="wait" custom={dir}>
                <motion.div
                  key={index}
                  custom={dir}
                  initial={{ opacity: 0, x: dir * 40 }}
                  animate={{ opacity: 1, x: 0 }}
                  exit={{ opacity: 0, x: dir * -40 }}
                  transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
                >
                  <p
                    data-testid="testimonial-quote"
                    className="font-body font-light text-base lg:text-xl leading-relaxed text-white/90 max-w-4xl mx-auto"
                  >
                    "{t.quote}"
                  </p>
                  <p data-testid="testimonial-author" className="font-body text-lg lg:text-xl text-white mt-8">
                    {t.name}
                  </p>
                </motion.div>
              </AnimatePresence>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
